import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const document_standard_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M6.5,4.5 L12.5,4.5 L17.5,9.5 L17.5,19.5 L6.5,19.5 L6.5,4.5 Z M17.5,9.5 L12.5,9.5 L12.5,4.5"
      />
    </svg>
  );
};
